export const COLORS_DATA = [
    {
        id: '124324',
        color: 'white',
        value: 'white'
    },
    {
        id: '1',
        color: 'yellow',
        value: '#FFF5EC'
    },
    {
        id: '2',
        color: 'pink',
        value: '#F5E7EA'
    },
    {
        id: '3',
        color: 'blue',
        value: '#E8EAF5'
    },
    {
        id: '4',
        color: 'green',
        value: '#DCEDDD'
    },
]

export const THEME_COLORS = {
    'white': 'white',
    'pink': '#F5E7EA',
    'yellow': '#FFF5EC',
    'blue': '#E8EAF5',
    'green': '#DCEDDD'
}